import { render, staticRenderFns } from "./DebtPointStats.vue?vue&type=template&id=a216c08e&"
import script from "./DebtPointStats.vue?vue&type=script&lang=js&"
export * from "./DebtPointStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports